import React from 'react';
import './PricingSection.css';
import { PricingPlan } from './types';
import PricingCard from './PricingCard';

const PricingSection = () => {
    const plans: PricingPlan[] = [
        {
            name: 'Free Plan',
            subtitle: 'For Individuals and small businesses up to 3 users',
            price: '$0.00',
            period: '/seat/month',
            planLink: '/katalife-free',
            button: {
                buttonText: 'Sign Up Now',
                buttonColor: 'secondary',
                buttonLink: 'https://app.kata.life/signup',
            },
            features: [
                { text: 'Up to 3 users', included: true },
                { text: 'Up to 3 active surveys per user', included: true },
                { text: '1 custom Survey Templates', included: true },
                { text: 'Unbelievably easy feedback user interface', included: true },
                { text: 'Customisable branding and call to action after feedback submitted', included: true },
                { text: 'Access to all Free Survey Templates', included: true },
                { text: 'Web portal and Mobile App for easy access', included: true },
                { text: 'Advanced Dashboards and Analytics on feedback and improvement areas', included: true },
                { text: 'Notifications on feedback', included: true },
                { text: 'Advanced Security features and industry standard data protection', included: true },
                { text: 'Community Customer Support', included: true }
            ]
        },
        {
            name: 'Professional Plan',
            subtitle: 'For medium sized teams and Businesses up to 100 users',
            price: 'AUD $2.00',
            period: '/seat/month',
            annualPrice: 'Annually (17% savings) $20.00/seat',
            recommended: true,
            planLink: 'https://business.kata.life',
            button: {
                buttonText: 'Sign up for 3 month trial',
                buttonColor: 'primary',
                buttonLink: 'https://app.kata.life/signup',
            },
            features: [
                { text: 'All features from free plan', included: true },
                { text: 'Up to 100 users', included: true },
                { text: 'Up to 5 active surveys per user', included: true },
                { text: 'Up to 10 custom Survey Templates', included: true },
                { text: 'Customisable branding and call to action after feedback submitted', included: true },
                { text: 'Access to all Free and Premium Survey Templates', included: true },
                { text: 'Create and manage teams for team level analytics', included: true },
                { text: 'API Integrations and Data Export', included: true },
                { text: 'Business Tier Customer Support, 24hr Response', included: true },
                { text: '99.0% uptime SLA', included: true }
            ]
        },
        {
            name: 'Enterprise Plan',
            subtitle: 'For large teams and businesses over 100 users',
            price: 'AUD $4.00',
            period: '/seat/month',
            annualPrice: 'Annually (17% savings) $40.00/seat',
            button: {
                buttonText: 'Contact Sales',
                buttonColor: 'secondary',
                buttonLink: '/Contact',
            },
            features: [
                { text: 'All features from Professional plan', included: true },
                { text: 'Unlimited active surveys', included: true },
                { text: 'Unlimited custom Survey Templates', included: true },
                { text: 'Enterprise Tier Customer Suppor, 4hr Response', included: true },
                { text: '99.95% uptime SLA', included: true }
            ]
        }
    ];

    return (
        <div>
            <section className="pricing-section">
                <div className="container">
                    <div className="pricing-header">
                        <h2>Choose Your Plan</h2>
                        <p>Select the perfect plan for your team</p>
                    </div>
                    {PricingCard(plans)}
                </div>
            </section>
        </div>
    );
};

export default PricingSection;
